<template>
  <div class="overlay" v-if="isVisible">
    <div class="addStudentModal">
      <b class="addStudent">Add Student</b>
      <div class="addStudentModalInner">
        <div class="availableStudentsParent">
          <div class="availableStudents">Students</div>
          <hilo-select
            style="width: 100%"
            :multi-select="true"
            :options="availableStudents"
            v-model="selectedStudents"
          ></hilo-select>
        </div>
      </div>
      <div class="addWrapper" @click="addStudent">
        <b class="add">Add</b>
      </div>
      <img
        @click="closeModal"
        class="vectorIcon1"
        alt=""
        src="/static/img/grey-x.svg"
      />
    </div>
  </div>
</template>
<script>
import HiloSelect from "../../../../../components/HiloComponents/HiloSelect.vue";
import activeStudentsAPIService from "../../../../../servicehandlers/ActiveStudentsAPIService";

const studentAPIService = new activeStudentsAPIService();
export default {
  name: "AddStudent",
  components: { HiloSelect },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      availableStudents: [],
      selectedStudents: [],
    };
  },
  mounted() {
    this.getStudents();
  },
  watch: {
    isVisible: {
      immediate: true,
      handler() {
        if (this.isVisible) this.getStudents();
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    getStudents() {
      return studentAPIService
        .getAvailableStudentsToClasses(this.$router)
        .then((response) => {
          this.availableStudents = response;
          for (let student of this.availableStudents) {
            student.name = student.firstName + " " + student.lastName;
          }
        });
    },
    addStudent() {
      this.$emit("add", this.selectedStudents);
      this.selectedStudents = [];
      this.closeModal();
    },
  },
};
</script>
<style scoped>
.addStudent {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.availableStudents {
  width: 160px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.select {
  position: relative;
}
.vectorIcon {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}
.selectParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
  color: rgba(64, 64, 64, 0.5);
}
.availableStudentsParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.addStudentModalInner {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 1;
}
.add {
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.addWrapper {
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 0;
  text-align: center;
  color: #fff;
}
.vectorIcon1 {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.addStudentModal {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  //overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  clip: unset;
  clip-path: none;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
